import {
  IMapField,
  IMapFieldTemplates,
  IupdateMapFieldBodyPropsUpdate,
} from 'interfaces/superAdmin.interface';
import * as MetaMapFieldsTypes from './metaMapFileds.types';
import {
  IInitialMetaState,
  IMap,
  IMapFieldMap,
  IShopifyConnectorMapsItem,
} from 'interfaces/meta.interface';

export type TMetaMapFieldsDispatchReducer =
  | {
      type: typeof MetaMapFieldsTypes.GET_MAP_FIELDS;
      payload: Array<IMapField>;
    }
  | {
      type: typeof MetaMapFieldsTypes.IS_LOADING_GET_MAP_FIELDS;
      payload: boolean;
    }
  | {
      type: typeof MetaMapFieldsTypes.CREATE_MAP_FIELD;
      payload: IMapField;
    }
  | {
      type: typeof MetaMapFieldsTypes.IS_LOADING_CREATE_MAP_FIELD;
      payload: boolean;
    }
  | {
      type: typeof MetaMapFieldsTypes.UPDATE_MAP_FIELD;
      payload: {
        id: string;
        data: IupdateMapFieldBodyPropsUpdate;
      };
    }
  | {
      type: typeof MetaMapFieldsTypes.IS_LOADING_UPDATE_MAP_FIELD;
      payload: boolean;
    }
  | {
      type: typeof MetaMapFieldsTypes.DELETE_MAP_FIELD;
      payload: string;
    }
  | {
      type: typeof MetaMapFieldsTypes.IS_LOADING_DELETE_MAP_FIELD;
      payload: {
        mapFieldId: string;
        loading: boolean;
      };
    }
  | {
      type: typeof MetaMapFieldsTypes.DELETE_MAP_FIELDS;
      payload: string[];
    }
  | {
      type: typeof MetaMapFieldsTypes.IS_LOADING_DELETE_MAP_FIELDS;
      payload: boolean;
    }
  | {
      type: typeof MetaMapFieldsTypes.ADD_FIELD_TO_MAP;
      payload: {
        mapId: string;
        mapField: IMapFieldMap;
      };
    }
  | {
      type: typeof MetaMapFieldsTypes.REMOVE_FIELD_FROM_MAP;
      payload: {
        mapId: string;
        mapFieldId: string;
      };
    }
  | {
      type: typeof MetaMapFieldsTypes.REMOVE_FIELDS_FROM_MAP;
      payload: {
        mapId: string;
        mapFieldsIds: string[];
      };
    }
  | {
      type: typeof MetaMapFieldsTypes.GET_MAP_FIELDS_TEMPLATES;
      payload: IMapFieldTemplates[];
    }
  | {
      type: typeof MetaMapFieldsTypes.IS_LOADING_GET_MAP_FIELDS_TEMPLATES;
      payload: boolean;
    }
  | {
      type: typeof MetaMapFieldsTypes.DELETE_MAP_FIELD_TEMPLATE;
      payload: string;
    }
  | {
      type: typeof MetaMapFieldsTypes.IS_LOADING_DELETE_MAP_FIELD_TEMPLATE;
      payload: {
        templateName: string;
        loading: boolean;
      };
    };

export function handleMapFields(
  state: IInitialMetaState,
  action: TMetaMapFieldsDispatchReducer
) {
  const { type, payload } = action;

  switch (type) {
    case MetaMapFieldsTypes.GET_MAP_FIELDS: {
      const getMapField: IInitialMetaState = {
        ...state,
        mapFields: payload,
      };
      return getMapField;
    }

    case MetaMapFieldsTypes.CREATE_MAP_FIELD: {
      const createMapField: IInitialMetaState = {
        ...state,
        mapFields: [payload, ...state.mapFields],
      };
      return createMapField;
    }

    case MetaMapFieldsTypes.UPDATE_MAP_FIELD: {
      const updateMapField: IInitialMetaState = {
        ...state,
        mapFields: state.mapFields.map((field) =>
          field.id === payload.id ? { ...field, ...payload.data } : field
        ),
        mapSelected: {
          ...state.mapSelected,
          map_field_maps: state.mapSelected?.map.map_field_maps.map((field) =>
            field.map_field_id === payload.id
              ? {
                  ...field,
                  map_field: {
                    ...field.map_field,
                    ...payload.data,
                  },
                }
              : field
          ),
        } as IShopifyConnectorMapsItem,
      };
      return updateMapField;
    }

    case MetaMapFieldsTypes.IS_LOADING_UPDATE_MAP_FIELD: {
      const isLoadingUpdateMapField: IInitialMetaState = {
        ...state,
        isLoadingUpdateMapField: payload,
      };
      return isLoadingUpdateMapField;
    }

    case MetaMapFieldsTypes.DELETE_MAP_FIELD: {
      const deleteMapField: IInitialMetaState = {
        ...state,
        mapFields: state.mapFields.filter((field) => field.id !== payload),
      };
      return deleteMapField;
    }

    case MetaMapFieldsTypes.DELETE_MAP_FIELDS: {
      const deleteMapFields: IInitialMetaState = {
        ...state,
        mapFields: state.mapFields.filter((field) => !payload.includes(field.id)),
      };
      return deleteMapFields;
    }

    case MetaMapFieldsTypes.IS_LOADING_DELETE_MAP_FIELDS: {
      const isLoadingDeleteMapFields: IInitialMetaState = {
        ...state,
        isLoadingDeleteMapFields: payload,
      };
      return isLoadingDeleteMapFields;
    }

    case MetaMapFieldsTypes.ADD_FIELD_TO_MAP: {
      const addFieldToMap: IInitialMetaState = {
        ...state,
        mappings: state.mappings.map((item) => {
          if (item.map.id === payload.mapId) {
            return {
              ...item,
              map: {
                ...item.map,
                map_field_maps: [...item.map.map_field_maps, payload.mapField],
              },
            };
          }
          return item;
        }),
      };
      return addFieldToMap;
    }

    case MetaMapFieldsTypes.REMOVE_FIELD_FROM_MAP: {
      const removeFieldFromMap: IInitialMetaState = {
        ...state,
        mappings: state.mappings.map((item) => {
          if (item.map.id === payload.mapId) {
            return {
              ...item,
              map: {
                ...item.map,

                map_field_maps: item.map.map_field_maps.filter(
                  (field) => field.map_field_id !== payload.mapFieldId
                ),
              },
            };
          }
          return item;
        }),
        mapSelected: {
          ...(state.mapSelected as IShopifyConnectorMapsItem),
          map: {
            ...(state.mapSelected?.map as IMap),
            map_field_maps: state.mapSelected?.map.map_field_maps.filter(
              (field) => field.map_field_id !== payload.mapFieldId
            ) as IMapFieldMap[],
          },
        },
      };
      return removeFieldFromMap;
    }

    case MetaMapFieldsTypes.REMOVE_FIELDS_FROM_MAP: {
      const removeFieldsFromMap: IInitialMetaState = {
        ...state,
        mappings: state.mappings.map((item) => {
          if (item.map.id === payload.mapId) {
            return {
              ...item,
              map: {
                ...item.map,
                map_field_maps: item.map.map_field_maps.filter(
                  (field) => !payload.mapFieldsIds.includes(field.map_field_id)
                ),
              },
            };
          }
          return item;
        }),
        mapSelected: {
          ...state.mapSelected,
          map: {
            ...state.mapSelected?.map,
            map_field_maps: state.mapSelected?.map.map_field_maps.filter(
              (field) => !payload.mapFieldsIds.includes(field.map_field_id)
            ) as IMapFieldMap[],
          },
        } as IShopifyConnectorMapsItem,
      };
      return removeFieldsFromMap;
    }

    case MetaMapFieldsTypes.IS_LOADING_GET_MAP_FIELDS: {
      const isLoadingGetMapFields: IInitialMetaState = {
        ...state,
        isLoadingMapFields: payload,
      };
      return isLoadingGetMapFields;
    }

    case MetaMapFieldsTypes.IS_LOADING_CREATE_MAP_FIELD: {
      const isLoadingCreateMapField: IInitialMetaState = {
        ...state,
        isLoadingCreateMapField: payload,
      };
      return isLoadingCreateMapField;
    }

    case MetaMapFieldsTypes.IS_LOADING_DELETE_MAP_FIELD: {
      const isLoadingDeleteMapField: IInitialMetaState = {
        ...state,
        isLoadingDeleteMapField: {
          loading: payload.loading,
          mapFieldId: payload.mapFieldId,
        },
      };
      return isLoadingDeleteMapField;
    }

    // Map fields templates //////////////////////////////////////////
    case MetaMapFieldsTypes.GET_MAP_FIELDS_TEMPLATES: {
      const getMapFieldsTemplates: IInitialMetaState = {
        ...state,
        mapFieldsTemplates: payload,
      };
      return getMapFieldsTemplates;
    }

    case MetaMapFieldsTypes.IS_LOADING_GET_MAP_FIELDS_TEMPLATES: {
      const isLoadingGetMapFieldsTemplates: IInitialMetaState = {
        ...state,
        isLoadingMapFieldsTemplates: payload,
      };
      return isLoadingGetMapFieldsTemplates;
    }

    case MetaMapFieldsTypes.DELETE_MAP_FIELD_TEMPLATE: {
      const deleteMapFieldTemplate: IInitialMetaState = {
        ...state,
        mapFieldsTemplates: state.mapFieldsTemplates.filter(
          (item) => item.templateName !== payload
        ),
      };
      return deleteMapFieldTemplate;
    }

    case MetaMapFieldsTypes.IS_LOADING_DELETE_MAP_FIELD_TEMPLATE: {
      const isLoadingDeleteMapFieldTemplate: IInitialMetaState = {
        ...state,
        isLoadingDeleteMapFieldTemplate: {
          loading: payload.loading,
          templateName: payload.templateName,
        },
      };
      return isLoadingDeleteMapFieldTemplate;
    }

    default:
      return state;
  }
}
